<div class="page" [class.dark]="isDark" [class.light]="!isDark">

    <button class="theme-toggle" (click)="toggleTheme()"
        [attr.aria-label]="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
        <svg *ngIf="isDark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round">
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
        <svg *ngIf="!isDark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round">
            <path d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z" />
        </svg>
    </button>

    <section class="right">
        <div id="mosaic">
            <div *ngFor="let cell of cells; let i = index" class="c" [class.win]="cell.type === 'win'"
                [class.dark]="cell.type === 'dark'" [class.cg]="cell.type === 'cg'" [class.cy]="cell.type === 'cy'">

                <ng-container *ngIf="cell.type === 'cg'">
                    <div>
                        <div class="lbl">Member Feature</div>
                        <h2>Precision Club Fitting</h2>
                        <p>AI-driven swing analysis matched to the perfect set</p>
                    </div>
                    <div class="ico">
                        <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="5" y1="21" x2="18" y2="8" stroke="rgba(255,255,255,0.7)" stroke-width="2"
                                stroke-linecap="round" />
                            <ellipse cx="4.5" cy="21.5" rx="3.5" ry="2" transform="rotate(-45 4.5 21.5)"
                                stroke="rgba(255,255,255,0.7)" stroke-width="1.4" fill="none" />
                            <path d="M20 4l1.2 3.8H25l-3 2.2 1.2 3.8L20 11.6l-3.2 2.2 1.2-3.8-3-2.2h3.8L20 4Z"
                                fill="rgba(255,255,255,0.6)" />
                        </svg>
                    </div>
                </ng-container>

                <ng-container *ngIf="cell.type === 'cy'">
                    <div>
                        <div class="fake-bar">
                            <span class="blink"></span>Book Tee Time
                        </div>
                        <div class="fake-icons">
                            <span></span><span></span><span></span><span></span><span></span>
                        </div>
                    </div>
                    <div>
                        <h2>Tee Time Booking</h2>
                        <p>Reserve at KGA courses with one tap</p>
                    </div>
                </ng-container>
            </div>
        </div>
    </section>
    <aside class="left">
        <div class="logo">
            <img src="/assets/KGA logo.svg" alt="KGA Logo" onerror="this.style.display='none'" />
        </div>

        <div class="badge">
            <span class="dot"></span>
            Est. 1973 · Bengaluru
        </div>

        <p class="org-name">Karnataka Golf Association</p>
        <!-- <h1>KGA Digitalization</h1> -->
         <h1>Club Ace</h1>
        <p class="subtitle">
            Sign in to manage your membership,<br />
            book tee times &amp; track your handicap
        </p>

        <ng-container *ngIf="currentScreen === 'login'">
            <div class="divider"><span>member login</span></div>
            <form [formGroup]="loginForm" style="width: 100%;" (ngSubmit)="onSubmit()">
                <!-- <div class="field">
                    <input type="email" placeholder="Email address" formControlName="email" name="email"
                        autocomplete="email"
                        [ngClass]="{'is-invalid': (submitted && f['email'].errors) || (f['email'].errors && f['email'].touched)}" />
                    <span class="field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <polyline points="22,6 12,13 2,6" />
                        </svg>
                    </span>
                    <div *ngIf="(submitted && f['email'].errors) || (f['email'].errors && f['email'].touched)"
                        class="invalid-feedback">
                        <div *ngIf="f['email'].errors?.['required']">
                            * Email is required
                        </div>
                        <div *ngIf="f['email'].errors?.['email']">
                            * Email is invalid
                        </div>
                    </div>
                </div> -->
                <div class="field">
                    <div class="input-wrapper">
                        <input type="email" placeholder="Email address" formControlName="email"
                            [ngClass]="{'is-invalid': (submitted && f['email'].errors) || (f['email'].errors && f['email'].touched)}" />

                        <span class="field-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                        </span>
                    </div>

                    <div *ngIf="(submitted && f['email'].errors) || (f['email'].errors && f['email'].touched)"
                        class="invalid-feedback">
                        <div *ngIf="f['email'].errors?.['required']">* Email is required</div>
                        <div *ngIf="f['email'].errors?.['email']">* Email is invalid</div>
                    </div>
                </div>

                <div class="field">
                    <div class="input-wrapper">
                        <input [type]="showPwd ? 'text' : 'password'" placeholder="Password" formControlName="password"
                            name="password" autocomplete="current-password"
                            [ngClass]="{'is-invalid': (submitted && f['password'].errors) || (f['password'].errors && f['password'].touched)}" />
                        <span class="field-icon clickable" (click)="showPwd = !showPwd">
                            <svg *ngIf="!showPwd" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path
                                    d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
                                <line x1="1" y1="1" x2="23" y2="23" />
                            </svg>
                            <svg *ngIf="showPwd" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                <circle cx="12" cy="12" r="3" />
                            </svg>
                        </span>
                    </div>

                    <div *ngIf="(submitted && f['password'].errors) || (f['password'].errors && f['password'].touched)"
                        class="invalid-feedback">
                        <div *ngIf="f['password'].errors?.['required']">
                            * Password is required
                        </div>
                        <div *ngIf="f['password'].errors?.['pattern']">
                            Password must be at least 7 characters and include an uppercase letter, number, and special
                            character.
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-2">
                    <span class="forgot-link" (click)="showResetPassword()">
                        Forgot Password?
                    </span>
                </div>

                <button class="btn-submit" type="submit">
                    {{loginBtnText}}
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14"
                        height="14">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </button>
            </form>
        </ng-container>

        <ng-container *ngIf="currentScreen === 'forgot'">

            <div class="divider"><span>Reset Password</span></div>

            <form [formGroup]="addForm" style="width: 100%;" (ngSubmit)="updatePassward()">
                <div class="field">
                    <div class="input-wrapper">
                        <input [type]="showPassword1 ? 'text' : 'password'" placeholder="New Password"
                            formControlName="newpassword"
                            [ngClass]="{'is-invalid': (submitted && g['newpassword'].errors) || (g['newpassword'].errors && g['newpassword'].touched)}" />

                        <span class="field-icon clickable" (click)="showPassword1 = !showPassword1">
                            <svg *ngIf="!showPassword1" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path
                                    d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
                                <line x1="1" y1="1" x2="23" y2="23" />
                            </svg>
                            <svg *ngIf="showPassword1" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                <circle cx="12" cy="12" r="3" />
                            </svg>
                        </span>
                    </div>

                    <div *ngIf="(submitted && g['newpassword'].errors) || (g['newpassword'].touched && g['newpassword'].errors)"
                        class="invalid-feedback">
                        <div *ngIf="g['newpassword'].errors?.['required']">
                            * New password is required
                        </div>
                        <div *ngIf="g['newpassword'].errors?.['pattern']">
                            Password must be at least 8 characters with upper, lower, number & special.
                        </div>
                    </div>
                </div>

                <div class="field">
                    <div class="input-wrapper">
                        <input [type]="showPassword2 ? 'text' : 'password'" placeholder="Confirm Password"
                            formControlName="password"
                            [ngClass]="{'is-invalid': (submitted && g['password'].errors) || (g['password'].errors && g['password'].touched)}" />

                        <span class="field-icon clickable" (click)="showPassword2 = !showPassword2">
                            <svg *ngIf="!showPassword2" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path
                                    d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
                                <line x1="1" y1="1" x2="23" y2="23" />
                            </svg>
                            <svg *ngIf="showPassword2" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                <circle cx="12" cy="12" r="3" />
                            </svg>
                        </span>
                    </div>

                    <div *ngIf="(submitted || g['password'].touched) && g['password'].errors" class="invalid-feedback">
                        <div *ngIf="g['password'].errors?.['required']">
                            * Confirm password is required
                        </div>
                        <div *ngIf="g['password'].errors?.['pattern']">
                            Password must be at least 8 characters with upper, lower, number & special.
                        </div>
                        <div *ngIf="g['password'].errors?.['passwordMismatch']">
                            * Passwords do not match
                        </div>
                    </div>
                </div>

                <button class="btn-submit" type="submit">
                    Reset Password
                </button>

                <button class="btn-submit mt-2" type="button" (click)="goBack()">
                    Back to Login
                </button>

            </form>
        </ng-container>

        <p class="powered">
            Powered by <strong><a (click)="openCanarys($event)"
                    style="cursor: pointer; text-decoration: none;">Canarys</a></strong>
        </p>

    </aside>
</div>